import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  DashboardOutlined,
  ChromeOutlined,
  QuestionOutlined,
  FileTextOutlined,
  AuditOutlined,
  ControlOutlined,
  TagOutlined,
  AppstoreOutlined,
  UserOutlined,
  CheckSquareOutlined,
  FormOutlined,
  ApartmentOutlined,
  SettingOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  ToolOutlined,
  UserSwitchOutlined,
  UserAddOutlined,
  IdcardOutlined,
  DoubleRightOutlined,
  DoubleLeftOutlined,
  LayoutOutlined,
  LineChartOutlined,
  OrderedListOutlined,
  ShopOutlined,
} from "@ant-design/icons";

const icons = {
  DashboardOutlined,
  TagOutlined, 
  AppstoreOutlined, // replaces CategoryOutlined
  UserOutlined,      // replaces PersonOutline
  CheckSquareOutlined, // replaces AssignmentTurnedInOutlined
  FormOutlined, // replaces Assignment
  ApartmentOutlined, // replaces SchemaOutlined
  SettingOutlined, // replaces SettingsOutlined
  EnvironmentOutlined, // replaces FmdGoodOutlined
  TeamOutlined, // replaces Groups
  ToolOutlined, // replaces Tune
  UserSwitchOutlined, // replaces SupervisorAccount
  UserAddOutlined, // replaces HowToReg
  IdcardOutlined, // replaces ManageAccounts
  DoubleRightOutlined, // replaces KeyboardDoubleArrowRight
  DoubleLeftOutlined, // replaces KeyboardDoubleArrowLeft
  LayoutOutlined, // replaces ViewQuiltOutlined
  LineChartOutlined, // replaces TimelineOutlined
  OrderedListOutlined, // replaces Checklist
  ShopOutlined, // replaces FactoryOutlined
  ControlOutlined,
  QuestionOutlined,
  ChromeOutlined,
  FileTextOutlined,
  AuditOutlined,
};

// ==============================|| MENU ITEMS ||============================== //

function Dashboard() {
  const [access_list_data, setaccess_list_data] = useState([]);
  const [refresh, set_refresh] = useState([]);

  const { t } = useTranslation();

  useEffect(() => {
    const storedData = localStorage.getItem("access_list_data");
    if (storedData) {
      setaccess_list_data(JSON.parse(storedData));
    } else {
      set_refresh(!refresh);
    }
  }, [refresh]);

  return [
    {
      id: "group-dashboard",
      title: "",
      type: "group",
      children: [
        {
          id: "dashboard",
          title: t("Dashboard"),
          type: "item",
          url: "/dashboard",
          icon: icons.DashboardOutlined,
          breadcrumbs: true,
          showMenu: access_list_data?.find(
            (item) => item.module_name === "Dashboard"
          )?.read_access,
        },
        {
          id: "notifications",
          title: "Notifications",
          type: "item",
          url: "/notifications",
          icon: icons.DashboardOutlined,
          breadcrumbs: true,
          showMenu: false,
        },
        {
          id: "calendar",
          title: "Calendar",
          type: "item",
          url: "/calendar",
          icon: icons.DashboardOutlined,
          breadcrumbs: true,
          showMenu: false,
        },
        {
          id: "tickets",
          title: t("Tickets"),
          type: "item",
          url: "/tickets",
          icon: icons.TagOutlined,
          breadcrumbs: true,
          showMenu: access_list_data?.find(
            (item) => item.module_name === "Tickets"
          )?.read_access,
        },
        // {
        //   id: "audit",
        //   title: t("Audit"),
        //   type: "item",
        //   url: "/audit",
        //   icon: icons.AuditOutlined,
        //   breadcrumbs: true,
        //   showMenu: access_list_data?.find(
        //     (item) => item.module_name === "Audit"
        //   )?.read_access,
        // },
        {
          id: "checklist",
          title: t("Checklist"),
          type: "item",
          url: "/checklist",
          icon: icons.OrderedListOutlined,
          breadcrumbs: true,
          showMenu: access_list_data?.find(
            (item) => item.module_name === "Checklist"
          )?.read_access,
        },
        // {
        //   id: "report",
        //   title: t("Report"),
        //   type: "item",
        //   url: "/report",
        //   icon: icons.FileTextOutlined,
        //   breadcrumbs: true,
        //   showMenu: access_list_data?.find(
        //     (item) => item.module_name === "Report"
        //   )?.read_access,
        // },
        {
          id: "Asset Management",
          title: t("Asset Management"),
          type: "collapse",
          icon: icons.AppstoreOutlined,
          breadcrumbs: true,
          showMenu: access_list_data?.find(
            (item) => item.module_name === "Asset Management"
          )?.read_access,
          children: [
            {
              id: "machine",
              title: t("Assets"),
              type: "item",
              url: "/asset",
              icon: icons.AppstoreOutlined,
              breadcrumbs: true,
              showMenu: access_list_data?.find(
                (item) => item.module_name === "Assets"
              )?.read_access,
            },
            {
              id: "analytics",
              title: t("Analytics"),
              type: "item",
              icon: icons.LineChartOutlined,
              url: "/analytics",
              breadcrumbs: true,
              showMenu: access_list_data?.find(
                (item) => item.module_name === "Analytics"
              )?.read_access,
            },
            {
              id: "asset-analytics2",
              title: t("Asset Analytics"),
              type: "item",
              icon: icons.LineChartOutlined,
              url: "/asset-analytic",
              breadcrumbs: true,
              showMenu: access_list_data?.find(
                (item) => item.module_name === "Asset Analytics"
              )?.read_access,
            },
          ],
        },

        {
          id: "spare_management",
          title: t("Spare Management"),
          type: "collapse",
          icon: icons.LayoutOutlined,
          breadcrumbs: true,
          showMenu: access_list_data?.find(
            (item) => item.module_name === "Spare Management"
          )?.read_access,
          children: [
            {
              id: "spare",
              title: t("Spares"),
              type: "item",
              url: "/spare-parts",
              icon: icons.LayoutOutlined,
              breadcrumbs: true,
              showMenu: access_list_data?.find(
                (item) => item.module_name === "Spares"
              )?.read_access,
            },
            {
              id: "inward",
              title: t("Inward"),
              type: "item",
              icon: icons.DoubleRightOutlined,
              url: "/spare-inward",
              breadcrumbs: true,
              showMenu: access_list_data?.find(
                (item) => item.module_name === "Inward"
              )?.read_access,
            },
            {
              id: "Outward",
              title: t("Outward"),
              type: "item",
              icon: icons.DoubleLeftOutlined,
              url: "/spare-outward",
              breadcrumbs: true,
              showMenu: true,
            },
            {
              id: "spare-analytics",
              title: t("Analytics"),
              type: "item",
              icon: icons.LineChartOutlined,
              url: "/spare-analytics",
              breadcrumbs: true,
              showMenu: access_list_data?.find(
                (item) => item.module_name === "Spare Analytics"
              )?.read_access,
            },
          ],
        },
        {
          id: "add-machine",
          title: "Add Machine",
          type: "item",
          url: "/add-asset",
          icon: icons.DashboardOutlined,
          breadcrumbs: true,
          showMenu: false,
        },
        {
          id: "asset-report",
          title: "Report",
          type: "item",
          url: "/asset-report",
          icon: icons.FormOutlined,
          breadcrumbs: true,
          showMenu: false,
        },

        {
          id: "ticket-details",
          title: "Ticket Details",
          type: "item",
          url: "/ticket-details",
          icon: icons.TagOutlined,
          breadcrumbs: true,
          showMenu: false,
        },
        {
          id: "create-ticket",
          title: "Create Ticket",
          type: "item",
          url: "/create-ticket",
          icon: icons.TagOutlined,
          breadcrumbs: true,
          showMenu: false,
        },
        {
          id: "maintenance-data",
          title: "Create Ticket",
          type: "item",
          url: "/maintenance-data",
          icon: icons.TagOutlined,
          breadcrumbs: true,
          showMenu: false,
        },
        {
          id: "break-down",
          title: "Create Ticket",
          type: "item",
          url: "/break-down",
          icon: icons.TagOutlined,
          breadcrumbs: true,
          showMenu: false,
        },
        {
          id: "user-profile",
          title: "User Profile",
          type: "item",
          url: "/user-profile",
          icon: icons.UserOutlined,
          breadcrumbs: true,
          showMenu: false,
        },
        // {
        //   id: "Visitor_Management",
        //   title: t("Visitor Management"),
        //   type: "collapse",
        //   icon: icons.IdcardOutlined,
        //   breadcrumbs: true,
        //   showMenu: access_list_data?.find(
        //     (item) => item.module_name === "Visitor Management"
        //   )?.read_access,
        //   children: [
        //     {
        //       id: "vendorConfig",
        //       title: t("Visitor Details"),
        //       type: "item",
        //       icon: icons.UserSwitchOutlined,
        //       url: "/visitor-details",
        //       breadcrumbs: true,
        //       showMenu: access_list_data?.find(
        //         (item) => item.module_name === "Visitor Details"
        //       )?.read_access,
        //     },
        //     {
        //       id: "vendorApproval",
        //       title: t("Visitor Approvals"),
        //       type: "item",
        //       icon: icons.UserAddOutlined,
        //       url: "/approveVendor",
        //       breadcrumbs: true,
        //       showMenu: access_list_data?.find(
        //         (item) => item.module_name === "Visitor Approvals"
        //       )?.read_access,
        //     },
        //   ],
        // },
        {
          id: "settings",
          title: t("Configurations"),
          type: "collapse",
          icon: icons.ToolOutlined,
          breadcrumbs: true,
          showMenu: access_list_data?.find(
            (item) => item.module_name === "Settings"
          )?.read_access,
          children: [
            {
              id: "ticketFlow",
              title: t("Ticket Work Flow"),
              type: "item",
              icon: icons.ApartmentOutlined,
              url: "/ticket-work-flow",
              breadcrumbs: true,
              showMenu: access_list_data?.find(
                (item) => item.module_name === "Ticket Work Flow"
              )?.read_access,
            },
            {
              id: "userConfig",
              title: t("Users"),
              type: "item",
              icon: icons.UserOutlined,
              url: "/user-configuration",
              breadcrumbs: true,
              showMenu: access_list_data?.find(
                (item) => item.module_name === "User Configuration"
              )?.read_access,
            },
            // {
            //   id: "AddLocation",
            //   title: t("Locations"),
            //   type: "item",
            //   icon: icons.EnvironmentOutlined,
            //   url: "/location-configuration",
            //   breadcrumbs: true,
            //   showMenu: access_list_data?.find(
            //     (item) => item.module_name === "Location Configuration"
            //   )?.read_access,
            // },
            // {
            //   id: "vendor-config",
            //   title: t("Vendors"),
            //   type: "item",
            //   icon: icons.ShopOutlined,
            //   url: "/vendor-configuration",
            //   breadcrumbs: true,
            //   showMenu: access_list_data?.find(
            //     (item) => item.module_name === "Vendors"
            //   )?.read_access,
            // },
            // {
            //   id: "designation-hierarchy",
            //   title: t("Designation Hierarchy"),
            //   type: "item",
            //   url: "/designation-hierarchy",
            //   icon: icons.ChromeOutlined,
            //   breadcrumbs: true,
            //   showMenu: access_list_data?.find(
            //     (item) => item.module_name === "Designation Hierarchy"
            //   )?.read_access,
            // },
            {
              id: "accessControl",
              title: t("Access Control"),
              type: "item",
              icon: icons.ControlOutlined,
              url: "/access-control",
              breadcrumbs: true,
              showMenu: access_list_data?.find(
                (item) => item.module_name === "Access Control"
              )?.read_access,
            },
            // {
            //   id: "Comapny Details",
            //   title: t("Company Details"),
            //   type: "item",
            //   icon: icons.TeamOutlined,
            //   url: "/company-profile",
            //   breadcrumbs: true,
            //   showMenu: access_list_data?.find(
            //     (item) => item.module_name === "Company Details"
            //   )?.read_access,
            // },
          ],
        },
      ],
    },

    {
      id: "support",
      title: t("Support"),
      type: "group",
      children: [
        {
          id: "documentation",
          title: t("Documentation"),
          type: "item",
          url: "https://nexgensis-1.gitbook.io/preventive-maintenance-web-application/",
          icon: icons.QuestionOutlined,
          external: true,
          target: true,
          showMenu: true,
        },
        // {
        //   id: "demo_flow",
        //   title: "Demo Ticket Work Flow",
        //   type: "item",
        //   icon: icons.SchemaOutlined,
        //   url: "/ticket-work-flow2",
        //   breadcrumbs: true,
        //   showMenu: true,
        // },
      ],
    },
  ].filter(Boolean);
}

export default Dashboard;
